module.exports = __webpack_public_path__ + "media/startCreatingListingsBanner.c338c272.png";